import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function Preloader() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1800);

    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {loading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          className="fixed inset-0 z-[99999] bg-[#2B1218] flex flex-col items-center justify-center pointer-events-none"
        >
          {/* Logo animation container */}
          <div className="relative flex flex-col items-center justify-center">
            <motion.div
              animate={{ scale: [0.95, 1.05, 0.95], rotate: [0, 2, -2, 0] }}
              transition={{ repeat: Infinity, duration: 2.2, ease: "easeInOut" }}
              className="relative z-10 p-4"
            >
              <img
                src="/images/mermaids/Logo1.svg"
                alt="Mermaids Only Loading"
                className="w-48 h-48 md:w-56 md:h-56 object-contain drop-shadow-xl"
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="flex items-center gap-2 mt-4"
            >
              <span className="w-2 h-2 rounded-full bg-[#F14909] animate-ping" />
              <span className="font-heading text-xl text-[#FAF3E0] tracking-widest uppercase font-bold">
                MERMAIDS <span className="text-[#FFA5C1]">ONLY</span>
              </span>
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
